import React from 'react';
import { Link } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

import TableUI from '../components/list/TableUI';
import CallPopup from '../components/call/CallPopup';
import MeetingPopup from '../components/meeting/MeetingPopup';
import CallAPI from '../api/CallAPI';
import MeetingAPI from '../api/MeetingAPI';
import LeadAPI from '../api/LeadAPI';
import Const from '../util/Constants';
import withRouter from '../util/WithRouter';
import Util from '../util/Util';
import LeadConst from '../util/LeadConst';

class Notifications extends React.Component {

  constructor(props) {
    super(props);
    this.state = { popup: null, model: null, calls: null, meetings: null, leadBods: null, leadAnns: null };
    this.models = reactLocalStorage.getObject(Const.Model);
    const user = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    this.User = `${Const.Opt}${user}${Const.Opt}`;

    this.callFields = [ 'model', 'date_time' ];
    this.meetingFields = [ 'model', 'date_time', 'responsible_person' ];
    this.leadFields = ['firstname', 'lastname', 'phone' ];
      
    const today = new Date();
    today.setHours(23);
    today.setMinutes(59);
    this.pagination = { currentPage: 1, pageCount: 1, perPage: 10 };
    const filters = [];
    filters.push({ field: 'responsible_person', type: 'multiselect~user',
      condition: 'equals', value: this.User });
    filters.push({ field: 'date_time', type: 'datetime',
      condition: 'end-with', value: `~${Util.dateToServerDateTime(today)}` });
    filters.push({ field: 'complete', type: 'complete', condition: 'in', value: '' });
    this.list = { filters, pagination: this.pagination };

    this.reminders = JSON.stringify(filters);

    this.showCall = Util.isAllow(this.models.call.permission, Const.PermView);
    this.CallUpdate = Util.isAllow(this.models.call.permission, Const.PermUpdate);
    this.showMeeting = Util.isAllow(this.models.meeting.permission, Const.PermView);
    this.MeetUpdate = Util.isAllow(this.models.meeting.permission, Const.PermUpdate);
    this.showBirthday = this.models.lead.fields.dob.visible ? true : false;
    this.showAnniversary = this.models.lead.fields.anniversary.visible ? true : false;
  }

  componentDidMount() {
    if(this.showCall) { this.loadCalls(); }
    if(this.showMeeting) { this.loadMeetings(); }
    if(this.showBirthday) { this.loadLeadBirthdays(); }
    if(this.showAnniversary) { this.loadLeadAnniversary(); }
  }
  loadCalls = () => CallAPI.getList(this.list, this.callsReceived);
  callsReceived = res => this.setState({ ...this.state, calls: res.data });

  loadMeetings = () => MeetingAPI.getList(this.list, this.meetingReceived);
  meetingReceived = res => this.setState({ ...this.state, meetings: res.data });

  loadLeadBirthdays = () => {
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    let value = `${Util.dateToServerDateTime(today)}~`;
    today.setHours(23);
    today.setMinutes(59);
    value += `${Util.dateToServerDateTime(today)}`;
    
    const filters = [];
    if(Util.isAllow(this.models.lead.permission, Const.PermRestricAcc)) {
      filters.push({ field: 'responsible_person', type: 'multiselect~user',
        condition: 'equals', value: this.User });
    }
    filters.push({ field: 'dob', type: 'date', condition: 'today', value });
    const list = { ...this.list, filters};

    this.birthdays = JSON.stringify(filters);
    LeadAPI.list(list, this.leadBirthdays);
  }
  leadBirthdays = res => this.setState({ ...this.state, leadBods: res.data });

  loadLeadAnniversary = () => {
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    let value = `${Util.dateToServerDateTime(today)}~`;
    today.setHours(23);
    today.setMinutes(59);
    value += `${Util.dateToServerDateTime(today)}`;
    
    const filters = [];
    if(Util.isAllow(this.models.lead.permission, Const.PermRestricAcc)) {
      filters.push({ field: 'responsible_person', type: 'multiselect~user',
        condition: 'equals', value: this.User });
    }
    filters.push({ field: 'anniversary', type: 'date', condition: 'today', value });
    const list = { ...this.list, filters};
    this.anniversary = JSON.stringify(filters);
    LeadAPI.list(list, this.leadAnniversary);
  }
  leadAnniversary = res => this.setState({ ...this.state, leadAnns: res.data });

  onPreview = (model, indx) => {
    if(model === 'call') {
      if(this.state.calls[indx].model_no === Const.Lead) {
        this.props.navigate(`/lead/preview/${this.state.calls[indx].model_id}`);
      } else if(this.state.calls[indx].model_no === Const.Contact) {
        this.props.navigate(`/contact/preview/${this.state.calls[indx].model_id}`);
      }
    } else if(model === 'meeting') {
      if(this.state.meetings[indx].model_no === Const.Lead) {
        this.props.navigate(`/lead/preview/${this.state.meetings[indx].model_id}`);
      } else if(this.state.meetings[indx].model_no === Const.Contact) {
        this.props.navigate(`/contact/preview/${this.state.meetings[indx].model_id}`);
      }
    } else if(model === 'leadb') {
      this.props.navigate(`${this.props.match.path}/preview/${this.data.leadBods[indx].id}`);
    } else if(model === 'leada') {
      this.props.navigate(`${this.props.match.path}/preview/${this.data.leadAnns[indx].id}`);
    } 
  }
  
  hidePopUp = () => this.setState({ ...this.state, popup: null });
  onEdit = (popup, index) => this.setState({ ...this.state, popup, 
    model: popup === LeadConst.Call ? this.state.calls[index] : this.state.meetings[index] });
  reload = () => {
    this.setState({ ...this.state, popup: null, calls: null, meetings: null });
    this.loadCalls();
    this.loadMeetings();
  }

  render() {
    const CallPopUp = this.CallUpdate ?
      <CallPopup show={this.state.popup === LeadConst.Call} onHide={this.hidePopUp}
        call={this.state.model} reload={this.reload} />
      : null;
    const MeetingPopUp = this.MeetUpdate ?
      <MeetingPopup show={this.state.popup === LeadConst.Meeting} onHide={this.hidePopUp}
        meeting={this.state.model} contacts={[]} reload={this.reload} />
      : null;

    return (
      <div>
        {CallPopUp} {MeetingPopUp}
        <div className="container-fluid pt-3 pb-3">
          { this.showCall &&
            <>
              <div className="row">
                <div className="col-md-8"><h4>Pending Calls</h4></div>
                <div className="col-md-1">
                  <Link to={`/call?filters=${this.reminders}`}>View All</Link>
                </div>
              </div>
              <div className="row">
                <TableUI
                  data={this.state.calls}
                  model={this.models.call}
                  fields={this.callFields}
                  pagination={this.pagination}
                  inApiCall={!this.state.calls}
                  preview={true}
                  update={this.CallUpdate}
                  onAddEdit={index => this.onEdit(LeadConst.Call, index)}
                  onPreview={indx => this.onPreview('call', indx)}
                  onDelete={() => {}}
                  onFieldSelection={() => {}}
                  isFilterOpen={true} />
              </div>
            </>
          }

          { this.showMeeting &&
            <>
              <div className="row">
                <div className="col-md-8"> <h4>Pending Meetings</h4> </div>
                <div className="col-md-1">
                  <Link to={`/meeting?filters=${this.reminders}`}>View All</Link>
                </div>
              </div>
              <div className="row">
                <TableUI
                  data={this.state.meetings}
                  model={this.models.meeting}
                  fields={this.meetingFields}
                  pagination={this.pagination}
                  inApiCall={!this.state.meetings}
                  preview={true}
                  update={this.MeetUpdate}
                  onAddEdit={index => this.onEdit(LeadConst.Meeting, index)}
                  onPreview={indx => this.onPreview('meeting', indx)}
                  onDelete={() => {}}
                  onFieldSelection={() => {}}
                  isFilterOpen={true} />
              </div>
            </>
          }

          { this.showBirthday &&
            <>
              <div className="row">
                <div className="col-md-8"> <h4>Lead Birthday</h4> </div>
                <div className="col-md-1">
                  <Link to={`/lead?filters=${this.birthdays}`}>View All</Link>
                </div>
              </div>
              <div className="row">
                <TableUI
                  data={this.state.leadBods}
                  model={this.models.lead}
                  fields={this.leadFields}
                  pagination={this.pagination}
                  inApiCall={!this.state.leadBods}
                  preview={true}
                  onAddEdit={() => {}}
                  onPreview={indx => this.onPreview('leadb', indx)}
                  onDelete={() => {}}
                  onFieldSelection={() => {}}
                  isFilterOpen={true} />
              </div>
            </>
          }

          { this.showAnniversary &&
            <>
              <div className="row">
                <div className="col-md-8"> <h4>Lead Anniversary</h4> </div>
                <div className="col-md-1">
                  <Link to={`/lead?filters=${this.anniversary}`}>View All</Link>
                </div>
              </div>
              <div className="row">
                <TableUI
                  data={this.state.leadAnns}
                  model={this.models.lead}
                  fields={this.leadFields}
                  pagination={this.pagination}
                  inApiCall={!this.state.leadAnns}
                  preview={true}
                  onAddEdit={() => {}}
                  onPreview={indx => this.onPreview('leada', indx)}
                  onDelete={() => {}}
                  onFieldSelection={() => {}}
                  isFilterOpen={true} />
              </div>
            </>
          }
        </div>
      </div>
    );
  }
}
export default withRouter(Notifications);